
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import EditNoteIcon from '@mui/icons-material/EditNote'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm'
import ArticleIcon from '@mui/icons-material/Article'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import MonitorIcon from '@mui/icons-material/Monitor'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import TitleBar from '../../components/uiParts/TitleBar'
import MenuIcon from '../../components/uiParts/MenuIcon'
import GradeIcon from '@mui/icons-material/Grade'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import AlarmAddIcon from '@mui/icons-material/AlarmAdd'
import FolderIcon from '@mui/icons-material/Folder'
import { useAuth } from '../../contexts/AuthContext'

const BidMastaMenu = () => {
    
    const { authInfo } = useAuth()
    const navigate = useNavigate()

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const loginUserId    = authInfo.userId
    const loginUserName  = authInfo.userName
    const lobinAuthority = authInfo.authority
    
	//===============================================
	// イベントハンドラ
	//===============================================
    const handleClick = (url) => {
        navigate(url)
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
        <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="入札マスタメニュー①" />
                    <MenuIcon header="maintenance Menu" title="荷主グループマスタ"  onClick={() => handleClick('/shipGroupList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="荷主マスタ"  onClick={() => handleClick('/shipList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="魚種マスタ"  onClick={() => handleClick('/fishSpecList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                <div>
                    <TitleBar title="入札マスタメニュー②" />
                    <MenuIcon header="maintenance Menu" title="規格グループマスタ"  onClick={() => handleClick('/standardGroupList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="規格マスタ"  onClick={() => handleClick('/standardList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="容器マスタ"  onClick={() => handleClick('/containerList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                <div>
                    <TitleBar title="入札マスタメニュー③" />
                    <MenuIcon header="maintenance Menu" title="メモマスタ"  onClick={() => handleClick('/memoList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="入札条件マスタ"  onClick={() => handleClick('/commentList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
            </div>
        </>
    )
}
export default BidMastaMenu

  